import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Card, CardBody, Row, Col, List, Label } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { adminPrefix } from "configs/routePrefix";
import { SuccessCreated } from "configs/statusCode";
import SuccessModal from "components/SucessModal";
import CancelModal from "components/CancelModal";
import Select from "react-select";
import { toast } from "react-toastify";
import ClientsService from "services/Admin/ClientsService";
// const countryCodes = require("country-codes-list");
import { getCountryListMap } from "country-flags-dial-code";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const CreateClientPage = (props) => {
	const [loading, setLoading] = useState(false);
	const clientsService = new ClientsService();
	const [formState, setFormState] = useState({
		first_name: "",
		last_name: "",
		user_name: "",
		email: "",
		phone: "",
		// country_code: '',
		// password: "",
		// password_confirmation: ""
	});
	const [touched, setTouched] = useState(false);
	const [modal, setModal] = useState(false);
	const [successModal, setSuccessModal] = useState(false);
	// const [showConfirmationPassword, setShowConfirmationPassword] = useState(true);
	// const [showPassword, setShowPassword] = useState(true);
	const [countriesCode, setCountriesCode] = useState([]);
	// const [error, setError]= useState({
	//   phone: false,
	//   email: false,
	//   first_name: false,
	//   user_name: false,
	//   last_name: false,
	//   // password: false
	// })

	useEffect(() => {
		// const myCountryCodesObject = countryCodes.customList(
		//   "countryCode",
		//   "{countryNameEn}/{countryNameLocal} +{countryCallingCode}"
		// );
		// const entries = Object.entries(myCountryCodesObject);
		// setCountriesCode(
		//   entries?.map((c) => {
		//     return {
		//     //   label: `${<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342">
		//     //   <path fill="#0052B4" d="M0 0h513v342H0z" />
		//     //   <path
		//     //     fill="#FFDA44"
		//     //     d="M513 210.9H202.2V342h-79.8V210.9H0V131.1h122.4V0h79.8v131.1H513v61.2z"
		//     //   />
		//     //   <path
		//     //     fill="#D80027"
		//     //     d="M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
		//     //   />
		//     // </svg>} ${c[1].split("+")[0]}`,
		//     label: (
		//       <div style={{ display: 'flex', alignItems: 'center' }}>
		//         <svg width={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342">
		//           <path fill="#0052B4" d="M0 0h513v342H0z" />
		//           <path
		//             fill="#FFDA44"
		//             d="M513 210.9H202.2V342h-79.8V210.9H0V131.1h122.4V0h79.8v131.1H513v61.2z"
		//           />
		//           <path
		//             fill="#D80027"
		//             d="M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
		//           />
		//         </svg>
		//         {c[1].split("+")[0]}
		//       </div>
		//     ),
		//       value: `+${c[1].split("+")[1]}`,
		//     };
		//   })
		// );

		const countrie = getCountryListMap();
		let x = Array.from(Object.values(countrie))?.map((res) => {
			return {
				value: `${res?.country} (${res?.dialCode})`,
				code: res?.dialCode,
				label: (
					<div style={{ display: "flex", alignItems: "center" }}>
						<img
							src={`data:image/svg+xml;utf8,${encodeURIComponent(res.flag)}`}
							alt={res?.dialCode}
							style={{ width: "20px", marginRight: "10px" }}
						/>
						{res?.country} ({res?.dialCode})
					</div>
				),
			};
		});

		setCountriesCode(x);
	}, []);

	const handleValidSubmit = () => {
		// if (!new RegExp(`^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*()_+\\-=\\[\\]{};':"\\|,.<>\\/?])(?!.*${formState.first_name+formState.last_name})(?!.*${formState.email}).{7,}$`).test(formState.password)
		//     ){
		//       setError((prev)=> ({...prev, password: true}))
		//   return
		// }
		if (!formState.phone) {
			setTouched(true);
			return;
		}
		let data = {
			...formState,
			// country_code: formState?.country_code?.code
		};
		setLoading(true);
		clientsService
			.create(data)
			.then((res) => {
				if (res && res.status === SuccessCreated) {
					setLoading(false);
					setSuccessModal(true);
				} else {
					setLoading(false);
					toast.error(res);
				}
			})
			.catch((e) => setLoading(false));
	};

	const handleFieldChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<MetaTags>
					<title>Client</title>
				</MetaTags>
				<Container fluid>
					<h4>Add Client</h4>
					<AvForm autoComplete="off" className="form-horizontal min-h-75vh">
						<Card className="w-100 mt-4">
							<CardBody>
								<Row className="mb-4">
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="first_name"
												label={"First Name"}
												placeholder={"First Name"}
												className="form-control"
												validate={{
													required: {
														value: true,
														errorMessage: "This Field is required",
													},
													pattern: {
														value: "^[A-Za-z]+$",
														errorMessage: "First Name format is invalid",
													},
												}}
												onChange={(e) => {
													handleFieldChange(e);
												}}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="last_name"
												label={"Last Name"}
												className="form-control"
												placeholder={"Last Name"}
												validate={{
													required: {
														value: true,
														errorMessage: "This Field is required",
													},
													pattern: {
														value: "^[A-Za-z]+$",
														errorMessage: "Last Name format is invalid",
													},
												}}
												onChange={(e) => {
													handleFieldChange(e);
												}}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="user_name"
												label={"User Name"}
												placeholder={"User Name"}
												validate={{
													required: {
														value: true,
														errorMessage: "This Field is required",
													},
													// pattern: {value: '^[a-zA-Z]+_[a-zA-Z]+$', errorMessage: "User Name format is invalid"}
												}}
												autoCompleteType="off"
												className="form-control"
												onChange={(e) => {
													handleFieldChange(e);
												}}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="email"
												label={"Email"}
												className="form-control"
												validate={{
													required: {
														value: true,
														errorMessage: "This Field is required",
													},
													pattern: {
														value:
															"^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$",
														errorMessage: "Email format is invalid",
													},
												}}
												onChange={(e) => {
													handleFieldChange(e);
												}}
												bsSize="lg"
												placeholder={"developer@gmail.com"}
											/>
										</div>
									</Col>
									<Col md={6}>
										<label className={touched ? "text-danger" : ""}>
											Phone
										</label>
										<PhoneInput
											country={"eg"}
											enableSearch={true}
											value={formState?.phone}
											onFocus={() => {
												setTouched(false);
											}}
											onBlur={() => {
												if (!formState?.phone) {
													setTouched(true);
												}
											}}
											onChange={(e) => {
												setTouched(false);
												setFormState({ ...formState, phone: e });
											}}
											inputStyle={{
												borderColor: touched ? "red" : "#ced4da",
											}}
										/>
										{touched && (
											<div
												className="text-danger"
												style={{ fontSize: "10px", marginTop: "4px" }}>
												This Field is required
											</div>
										)}
										{/* <div className="d-flex">
                      <Select
                        placeholder='Select'
                        options={countriesCode}
                        className='w-25'
                        value={formState.country_code}
                        onChange={e => {
                          setFormState({...formState, country_code: e})
                        }}
                      />
                      <AvField
                        name="phone"
                        placeholder={"123456789"}
                        className='form-control w-75'
                        validate={{
                          required: {value: true, errorMessage: 'This Field is required'},
                          // pattern: {value: '^[0-9]+$', errorMessage: "The Phone format is invalid"},
                          // minLength: {value: 11, errorMessage: 'The Phone must be 11 characters'},
                          // maxLength: {value: 11, errorMessage: 'The Phone must be 11 characters'},
                        }}
                        onChange={(e) => {
                          handleFieldChange(e)
                        }}
                        bsSize="lg"
                        type="number"
                      />
                    </div> */}
									</Col>
									<Col md={6}>
										{/* <div className='mb-3'>
                      <AvField
                        name="phone"
                        label={"Phone"}
                        placeholder={"123456789"}
                        className='form-control'
                        validate={{
                          required: {value: true, errorMessage: 'This Field is required'},
                          // pattern: {value: '^[0-9]+$', errorMessage: "The Phone format is invalid"},
                          // minLength: {value: 11, errorMessage: 'The Phone must be 11 characters'},
                          // maxLength: {value: 11, errorMessage: 'The Phone must be 11 characters'},
                        }}
                        onChange={(e) => {
                          handleFieldChange(e)
                        }}
                        bsSize="lg"
                        type="number"
                      />
                    </div> */}
									</Col>
									{/* <Col md={6}>
                    <div className='mb-3'>
                      {!!error["password"] && <Label className='error-text'>Password</Label>}
                      <AvField
                        name='password'
                        label={!error["password"] && 'Password'}
                        className='form-control position-relative'
                        placeholder='Password'
                        style={{borderColor: error["password"] && "#dc3545"}}
                        type={showPassword ? 'password' : "text"}
                        validate= {{
                          required: {value: true, errorMessage: 'This Field is required'},
                          minLength: {value: 7, errorMessage: 'Password must be 7 characters or more'},
                        }}
                        minLength={7}
                        required
                        onChange={(e) => {
                          setError((prev)=> ({...prev, password: false}))
                          handleFieldChange(e)
                        }}
                        bsSize="lg"
                      />
                      {error["password"] && <p className="mb-2 error-text mt-1 font-size-11">The password format is invalid.</p>}
                    </div>
                    <div style={{
                            position: "absolute",
                            top: "19%",
                            right: "20px",

                          }} onClick={() => setShowPassword(!showPassword)} >
                            {formState.password?.trim().length !== 0 ? showPassword ?
                              <i className="fas fa-eye-slash"></i>
                              :
                              <i className="fas fa-eye  "></i> : null}
                          </div>
                          <Row>
                                    <List>
                                        <ul>
                                            <li>Password must be 7 characters or more</li>
                                            <li>Password must have a capital & small letter</li>
                                            <li>Password must have a number</li>
                                            <li>Password must have a special character</li>
                                            <li>Password cannot be your name or email address</li>
                                        </ul>
                                    </List>
                                </Row>
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        name='password_confirmation'
                        label="Password Confirmation"
                        className='form-control position-relative'
                        placeholder='Password Confirmation'
                        type={showConfirmationPassword ? 'password' : "text"}
                        validate= {{
                          required: {value: true, errorMessage: 'This Field is required'},
                          minLength: {value: 7, errorMessage: 'Password must be 7 characters or more'},
                        }}
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                      />
                    </div>
                    <div style={{
                            position: "absolute",
                            top: "19%",
                            right: "20px",

                          }} onClick={() => setShowConfirmationPassword(!showConfirmationPassword)} >
                            {formState?.password_confirmation?.trim().length !== 0 ? showConfirmationPassword ?
                              <i className="fas fa-eye-slash"></i>
                              :
                              <i className="fas fa-eye  "></i> : null}
                          </div>
                  </Col> */}
								</Row>
							</CardBody>
						</Card>
						<Row className="d-flex justify-content-between pb-4">
							<Col>
								<button
									type="button"
									className="btn btnUpload btnHeight px-4"
									onClick={() => {
										setModal(true);
									}}
									size={"lg"}>
									Cancel
								</button>
							</Col>
							<Col>
								<button
									type="submit"
									onClick={() => {
										if (!formState.phone) {
											setTouched(true);
										}
										handleValidSubmit();
									}}
									className="btn btn-success btnHeight px-4 float-end"
									size={"lg"}
									disabled={loading}>
									Submit
								</button>
							</Col>
						</Row>
						<CancelModal
							modal={modal}
							setModal={setModal}
							goBackHandler={() =>
								props.history.push(`${adminPrefix}/manage-clients`)
							}
						/>
					</AvForm>
					<SuccessModal
						modal={successModal}
						message="Added Client Successfully"
						onClick={() => {
							props.history.push(`${adminPrefix}/manage-clients`);
						}}
						title="Add Client"
					/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default CreateClientPage;
